/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const deviceSchema = z.object({
  id: z.string(),
  platform: z.string(),
  deviceModel: z.string(),
  osName: z.string().nullable(),
  osVersion: z.string().nullable(),
  browserName: z.string().nullable(),
  browserVersion: z.string().nullable(),
  lastSeenAt: z.number(),
  createdAt: z.number(),
});

export type IDevice = z.infer<typeof deviceSchema>;
